<template>
  <!-- 列表 -->
  <el-row
    v-if="
      (table && table.fieldList) || (fieldList && fieldList.length > 0) || file
    "
    :gutter="10"
    style="height：auto"
  >
    <el-col :span="24">
      <el-card :shadow="shadow || 'never'" :class="noBorder && 'no-border'">
        <slot name="customHeader" />
        <div v-if="formTitle" class="panel-title">{{ formTitle }}</div>
        <template v-if="table && table.fieldList">
          <div v-if="table.total" class="totalRemarks">
            <ul>
              <li v-for="(item, index) in table.total" :key="index">
                {{ item.label }}：
                <b>{{ table.totalData[item.value] }}</b>
                {{ item.remark }}
              </li>
            </ul>
            <el-divider />
          </div>
          <div :class="table.class">
            <span class="red">{{ remark }}</span>
            <div>
              <el-table
                ref="formTable"
                :data="table.data"
                @select-all="handleSelectionChange"
                @select="handleSelectionChange"
                :row-class-name="tableRowClassName"
                :row-key="tableRowKey"
                :height="table.height || undefined"
                fit
                size="mini"
                style="width: 100%"
                highlight-current-row
              >
                <template v-for="(item, index) in getTableConfigList">
                  <!-- 单选框 -->
                  <el-table-column
                    v-if="item.type === 'selection'"
                    :key="index"
                    :reserve-selection="table.reserveSelection"
                    type="selection"
                    width="55"
                  />
                  <!-- 普通输入框 -->
                  <el-table-column
                    v-else-if="item.type === 'input'"
                    :key="index"
                    :prop="item.prop"
                    :disabled="item.disabled"
                    :label="item.label"
                    :width="item.width"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <el-input
                        :style="`width:${item.width}px;`"
                        v-model="table.data[scope.$index][item.value]"
                        :placeholder="getPlaceholder(item)"
                        :disabled="item.disabled || scope.row.disabled"
                      />
                    </template>
                  </el-table-column>
                  <!-- 多行输入框 -->
                  <el-table-column
                    v-else-if="item.type === 'textarea'"
                    :key="index"
                    :prop="item.prop"
                    :disabled="item.disabled"
                    :label="item.label"
                    :width="item.width"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <el-input
                        v-model="table.data[scope.$index][item.value]"
                        :type="item.type"
                        :autosize="item.autosize || { minRows: 1, maxRows: 4 }"
                        :disabled="item.disabled || scope.row.disabled"
                        :clearable="
                          item.clearable === false ? item.clearable : true
                        "
                        :placeholder="getPlaceholder(item)"
                        @focus="handleEvent(item.event)"
                      />
                    </template>
                  </el-table-column>
                  <!-- 数字输入框 -->
                  <el-table-column
                    v-else-if="item.type === 'number'"
                    :key="index"
                    :prop="item.prop"
                    :disabled="item.disabled"
                    :label="item.label"
                    :width="item.width"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <el-input-number
                        v-model="table.data[scope.$index][item.value]"
                        :placeholder="getPlaceholder(item)"
                        :disabled="item.disabled"
                        :min="scope.row.min || 0"
                        :max="scope.row.max"
                        :precision="item.precision || 0"
                        controls-position="right"
                        @change="handleEvent(item.event, scope)"
                      />
                    </template>
                  </el-table-column>
                  <!-- 选择框 -->
                  <el-table-column
                    v-else-if="item.type === 'select' && item.show !== false"
                    :key="index"
                    :label="item.label"
                    :prop="item.prop"
                    :type="item.type"
                    show-overflow-tooltip
                    :width="item.width"
                  >
                    <template slot-scope="scope">
                      <el-select
                        v-if="item.type === 'select'"
                        v-model="table.data[scope.$index][item.value]"
                        :label-width="item.labelWidth"
                        :disabled="item.disabled || scope.row.disabled"
                        :clearable="
                          item.clearable === false ? item.clearable : true
                        "
                        :filterable="item.filterable"
                        remote
                        :remote-method="(query) => remoteMethod(item, query)"
                        :loading="item.loading || false"
                        :placeholder="getPlaceholder(item)"
                        @change="handleEvent(item.event, scope)"
                        style="width:130px"
                      >
                        <el-option
                          v-for="(childItem, childIndex) in listTypeInfo[
                            item.list
                          ]"
                          :key="childIndex"
                          :label="childItem.key"
                          :value="childItem.value"
                        />
                      </el-select>
                      <el-tooltip
                        v-if="item.tipEvent && (!item.disabled && !scope.row.disabled)"
                        class="item"
                        :content="item.content"
                        placement="bottom-start"
                      >
                        <el-button
                          type="text"
                          @click="handleClick(item.tipEvent)"
                        >
                          <i class="el-icon-circle-plus" />
                        </el-button>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <!-- 选择器 -->
                  <el-table-column
                    v-else-if="item.type === 'picker'"
                    :key="index"
                    :prop="item.prop"
                    :label="item.label"
                    :width="item.width"
                    show-overflow-tooltip
                  >
                    <!-- 日期、时间选择器 -->
                    <template slot-scope="scope">
                      <el-col v-if="item.date" :span="11">
                        <el-date-picker
                          v-model="table.data[scope.$index][item.date.value]"
                          type="date"
                          value-format="yyyy-MM-dd"
                          :placeholder="getPlaceholder(item)"
                          :disabled="item.disabled || scope.row.disabled"
                          :picker-options="option"
                          style="width: 100%"
                        />
                      </el-col>
                      <el-col v-else-if="item.startTime" :span="11">

                        <el-time-select
                          v-if="item.startTime.type === 'timeSelect'"
                          v-model="
                            table.data[scope.$index][item.startTime.value]
                          "
                          :picker-options="
                            item.startTime.pickerOptions || {
                              start: '00:30',
                              step: '00:30',
                              end: '24:00',
                            }
                          "
                          :disabled="item.disabled"
                          :placeholder="getPlaceholder(item)"
                        />
                        <el-time-picker
                          v-else
                          v-model="
                            table.data[scope.$index][item.startTime.value]
                          "
                          :placeholder="getPlaceholder(item)"
                          :disabled="item.disabled"
                          format="HH:mm"
                          value-format="HH:mm"
                          style="width: 100%"
                        />
                      </el-col>
                      <el-col
                        v-if="(item.date || item.startTime) && item.time"
                        class="line text-center"
                        :span="1"
                      >-</el-col
                      >
                      <el-col v-if="item.time" :span="11">
                        <el-time-select
                          v-if="item.time.type === 'timeSelect'"
                          v-model="table.data[scope.$index][item.time.value]"
                          :picker-options="
                            item.time.pickerOptions || {
                              start: '00:30',
                              step: '00:30',
                              end: '24:00',
                            }
                          "
                          :disabled="item.disabled  || scope.row.disabled"
                          :placeholder="getPlaceholder(item)"
                          style="width:100%"
                        />
                        <el-time-picker
                          v-else
                          v-model="table.data[scope.$index][item.time.value]"
                          :placeholder="getPlaceholder(item)"
                          :disabled="item.disabled"
                          format="HH:mm"
                          value-format="HH:mm"
                          style="width: 100%"
                        />
                      </el-col>
                    </template>
                  </el-table-column>
                  <!-- 删除按钮 -->
                  <el-table-column
                    v-else-if="item.type === 'delete' && item.show !== false"
                    :key="index"
                    :label="item.label"
                    :width="item.width"
                  >
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        size="mini"
                        icon="el-icon-delete"
                        :disabled="item.disabled"
                        @click="handleClick(item.event, scope.$index)"
                      />
                    </template>
                  </el-table-column>
                  <!-- 图标按钮 -->
                  <el-table-column
                    v-else-if="item.type == 'actions'"
                    :key="index"
                    :label="item.label"
                    :width="item.width"
                  >
                    <template slot-scope="scope">
                      <template v-for="(bt, i) in table.handle.btList">
                        <el-tooltip
                          :key="i"
                          class="item"
                          :content="bt.label"
                          placement="bottom-start"
                        >
                          <el-button
                            plain
                            size="mini"
                            :type="bt.type"
                            :icon="bt.icon"
                            circle
                            @click="handleClick(bt.event, scope.row)"
                          >
                            <svg-icon
                              v-if="bt.iconClass"
                              :icon-class="bt.iconClass"
                            />
                          </el-button>
                        </el-tooltip>
                      </template>
                    </template>
                  </el-table-column>
                  <!-- 增加\删除行按钮 -->
                  <el-table-column
                    v-else-if="item.type === 'line' && item.show !== false"
                    :key="index"
                    align="right"
                    :width="item.width"
                  >
                    <template slot="header" slot-scope="scope">
                      <el-button
                        v-if="item.btnPlusShow !== false"
                        type="info"
                        class="el-icon-plus"
                        size="mini"
                        :disabled="item.disabled"
                        @click="handleClick(item.addEvent, scope)"
                      />
                    </template>
                    <template slot-scope="scope">
                      <el-button
                        v-if="table.data.length > 0 && !table.data[scope.$index][`${item.prop}_isReplaceText`]"
                        size="mini"
                        type="danger"
                        class="el-icon-minus"
                        :disabled="item.disabled || scope.row.disabled"
                        @click="handleClick(item.removeEvent, scope.$index)"
                      />
                      <el-tag
                        v-if="table.data.length > 0 && table.data[scope.$index][`${item.prop}_isReplaceText`]"
                      >{{table.data[scope.$index][`${item.prop}_replaceText`]}}</el-tag>
                    </template>
                  </el-table-column>
                  <!-- 联级选择器 -->
                  <el-table-column
                    v-else-if="item.type === 'cascader'"
                    :key="index"
                    :label="item.label"
                    :width="item.width"
                  >
                    <template slot-scope="scope">
                      <el-cascader
                        v-model="table.data[scope.$index][item.value]"
                        :options="listTypeInfo[item.list]"
                        :props="{ expandTrigger: 'hover' }"
                        tyle="width:100%"
                        :disabled="
                          item.disabled ||
                          table.data[scope.$index].columnDisabled
                        "
                      ></el-cascader>
                    </template>
                  </el-table-column>
                  <!-- popover -->
                  <el-table-column
                    v-else-if="item.type === 'popover'"
                    :key="index"
                    :label="item.label"
                    :width="item.width"
                  >
                    <template slot-scope="scope">
                      <slot name="popover" :scope="scope" />
                    </template>
                  </el-table-column>
                  <!-- 普通文本 -->
                  <el-table-column
                    v-else-if="item.show !== false"
                    :key="index"
                    :label="item.label"
                    :prop="item.prop"
                    :type="item.type"
                    show-overflow-tooltip
                    :width="item.width"
                  />
                </template>
              </el-table>
            </div>
          </div>
        </template>
        <!-- 表单 -->
        <template v-if="fieldList && fieldList.length > 0">
          <el-form
            ref="pageform"
            :model="data"
            required
            size="mini"
            label-width="100px"
          >
            <el-col
              v-for="(item, index) in getConfigList()"
              :key="index"
              :xs="item.xs || 12"
              :sm="item.sm || 12"
              :md="item.md || 12"
              :lg="item.lg || 12"
              :xl="item.xl || 12"
            >
              <el-form-item :label="$t(item.label)" :required="item.required">
                <!-- 选择框 -->
                <el-select
                  style="width: 220px"
                  v-if="item.type === 'select'"
                  v-model="data[item.value]"
                  :label-width="item.labelWidth"
                  :disabled="item.disabled"
                  :multiple="item.multiple"
                  remote
                  :remote-method="(query) => remoteMethod(item, query)"
                  :clearable="item.clearable === false ? item.clearable : true"
                  :filterable="item.filterable"
                  :placeholder="getPlaceholder(item)"
                  @change="handleEvent(item.event, data[item.value])"
                >
                  <el-option
                    v-for="(childItem, childIndex) in listTypeInfo[item.list]"
                    :key="childIndex"
                    :label="childItem.key"
                    :value="childItem.value"
                  />
                </el-select>
                <!-- 数字输入框 -->
                <el-input-number
                  style="width: 220px"
                  v-else-if="item.type === 'number'"
                  v-model="data[item.value]"
                  :placeholder="getPlaceholder(item)"
                  :disabled="item.disabled"
                  :min="item.min || 0"
                  :max="item.max"
                  :precision="item.precision || 0"
                  controls-position="right"
                />
                <!-- 普通输入框 -->
                <template v-else-if="item.type === 'input'">
                  <el-input
                  style="width: 220px"
                  v-model="data[item.value]"
                  :placeholder="getPlaceholder(item)"
                  :disabled="item.disabled"
                  />
                  <div v-if="item.remark" class="remark">{{ item.remark }}</div>
                </template>
                <!-- 密码输入框 -->
                <el-input
                  style="width: 220px"
                  v-else-if="item.type === 'password'"
                  v-model="data[item.value]"
                  :placeholder="getPlaceholder(item)"
                  :disabled="item.disabled"
                  type="password"
                />
                <!--多行输入框 -->
                <el-input
                  v-else-if="item.type === 'textarea'"
                  v-model="data[item.value]"
                  :placeholder="getPlaceholder(item)"
                  :disabled="item.disabled"
                  type="textarea"
                />
                <!-- 二选一单选框 -->
                <template v-else-if="item.type === 'radio'">
                  <el-radio-group
                    v-model="data[item.value]"
                    @change="(value) => handleEvent(item.event, value)"
                  >
                    <el-radio
                      :label="item.yes || 'Y'"
                      :disabled="item.disabled"
                      :placeholder="item.yesLabel || getPlaceholder(item)"
                    >{{ item.yesLabel || $t("table.yes") }}</el-radio
                    >
                    <el-radio
                      :label="item.no || 'N'"
                      :disabled="item.disabled"
                      :placeholder="item.noLabel || getPlaceholder(item)"
                    >{{ item.noLabel || $t("table.no") }}</el-radio
                    >
                  </el-radio-group>
                </template>
                <!-- 时间范围选择 -->
                <template v-else-if="item.type === 'picker'">
                  <el-col :span="11">
                    <el-time-picker
                      v-model="data[item.startTime.value]"
                      :placeholder="getPlaceholder(item)"
                      :disabled="item.disabled"
                      format="HH:mm"
                      value-format="HH:mm"
                      style="width: 100%"
                    />
                  </el-col>
                  <el-col
                    v-if="item.startTime && item.endTime"
                    class="line text-center"
                    :span="1"
                  >-</el-col
                  >
                  <el-col :span="11">
                    <el-time-picker
                      v-model="data[item.endTime.value]"
                      :placeholder="getPlaceholder(item)"
                      :disabled="item.disabled"
                      format="HH:mm"
                      value-format="HH:mm"
                      style="width: 100%"
                    />
                  </el-col>
                </template>
                <!-- 日期范围选择 -->
                <el-date-picker
                  v-else-if="item.type === 'daterange'"
                  v-model="data[item.value]"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="item.options"
                />
                <!-- 日期选择 -->
                <el-date-picker
                  v-else-if="item.type === 'date'"
                  v-model="data[item.value]"
                  value-format="yyyy-MM-dd"
                  align="right"
                  :placeholder="getPlaceholder(item)"
                  :picker-options="item.options"
                  :format="item.format || 'yyyy-MM-dd'"
                />
                <!-- 日期、时间选择器 -->
                <template v-else-if="item.type === 'dateTime'">
                  <el-col v-if="item.date" :span="11">
                    <el-date-picker
                      v-model="data[item.date.value]"
                      value-format="yyyy-MM-dd"
                      type="date"
                      :placeholder="getPlaceholder(item)"
                      :disabled="item.disabled"
                      style="width: 100%"
                    />
                  </el-col>
                  <el-col v-if="!item.date" :span="item.span || 11">
                    <el-date-picker
                      v-model="data[item.value]"
                      :format="item.format || 'yyyy-MM-dd HH:mm'"
                      type="datetime"
                      :placeholder="getPlaceholder(item)"
                      :disabled="item.disabled"
                      style="width: 100%"
                    />
                  </el-col>
                  <el-col v-else-if="item.startTime" :span="11">
                    <el-time-picker
                      v-model="data[item.startTime.value]"
                      :placeholder="getPlaceholder(item)"
                      :disabled="item.disabled"
                      format="HH:mm"
                      value-format="HH:mm"
                      style="width: 100%"
                    />
                  </el-col>
                  <el-col
                    v-if="(item.date || item.startTime) && item.time"
                    class="line text-center"
                    :span="1"
                  >-</el-col
                  >
                  <el-col v-if="item.time" :span="11">
                    <el-time-select
                      v-if="item.time.type === 'timeSelect'"
                      v-model="data[item.time.value]"
                      :disabled="item.disabled"
                      :picker-options="{
                        start: '00:30',
                        step: '00:30',
                        end: '24:00',
                      }"
                      :placeholder="getPlaceholder(item)"
                    />
                    <el-time-picker
                      v-else
                      v-model="data[item.time.value]"
                      :placeholder="getPlaceholder(item)"
                      :disabled="item.disabled"
                      format="HH:mm"
                      value-format="HH:mm"
                      style="width: 100%"
                    />
                  </el-col>
                </template>
                <!-- 地址选择 -->
                <div v-else-if="item.type === 'address'" class="item-inline">
                  <el-col :span="18">
                    <el-input
                      v-model="data[item.value]"
                      :disabled="item.disabled"
                      placeholder="地址"
                    />
                  </el-col>
                  <el-col :span="4">
                    <el-button
                      size="mini"
                      :disabled="item.disabled"
                      @click="handleClick(item.event)"
                    >获取经纬度</el-button
                    >
                  </el-col>
                </div>
                <!-- 城市选择 -->
                <el-cascader
                  v-else-if="item.type === 'cities'"
                  v-model="data[item.value]"
                  :props="{ value: 'label' }"
                  :options="citiesOP"
                  filterable
                  style="width: 100%"
                  :disabled="item.disabled"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <slot />
            </el-col>
          </el-form>
        </template>
        <!-- 文件上传 -->
        <template v-if="file && file.show !== false">
          <template v-if="file.type !== 'image' && file.type === 'upload'">
            <div class="panel-title">{{ file.name }}导入</div>
            <el-alert
              :closable="false"
              title="提示：导入仅支持xlsx/xls格式的文件"
              type="success"
            />
          </template>
          <template v-else="file.type === 'uploadImagePdf'">
            <div class="panel-title">{{ file.name }}</div>
            <el-alert
              :closable="false"
              title="提示：上传文件仅支持.jpeg和.jpg、.png等后缀的图片文件"
              type="success"
            />
          </template>

          <br/>
          <div class="file-radio" v-if="file.radio" >
            <span>订单类型：</span><el-radio v-for="(radio, index) in file.radio.fieldList" :key="index" v-model="file.radio.value" :label="index">{{radio.label}}</el-radio>
          </div>

          <el-form label-width="90px" size="mini" style="margin-top: 15px">
            <el-form-item :label="file.type !== 'image' && '文件上传'">
              <el-upload
                :action="file.action || ''"
                :list-type="file.listType"
                class="upload-demo"
                ref="upload"
                :on-exceed="handleExceed"
                :limit="file.limit"
                :multiple="true"
                :file-list="file.fileList"
                :before-upload="beforeUpload"
                :accept="file.accept"
                :auto-upload="false"
                :headers="{ 'Content-Type': 'multipart/form-data' }"
              >
                <template v-if="file.type == 'image'">
                  <i slot="default" class="el-icon-plus" />
                  <div slot="file" slot-scope="{ fileItem }">
                    <img
                      class="el-upload-list__item-thumbnail"
                      :src="fileItem.url"
                      alt
                    />
                    <span class="el-upload-list__item-actions">
                      <span
                        class="el-upload-list__item-preview"
                        @click="handlePictureCardPreview(fileItem)"
                      >
                        <i class="el-icon-zoom-in" />
                      </span>
                      <span
                        v-if="!disabled"
                        class="el-upload-list__item-delete"
                        @click="handleRemove(fileItem)"
                      >
                        <i class="el-icon-delete" />
                      </span>
                    </span>
                  </div>
                  <div class="el-upload__tip" slot="tip">
                    提示：必须选择后缀.jpg或.png图片文件
                  </div>
                </template>
                <template v-else-if="file.type == 'apk'">
                  <el-button
                    slot="trigger"
                    size="small"
                    :disabled="file.disabled"
                    type="primary"
                  >选取文件</el-button
                  >
                  <el-button
                    style="margin-left: 10px; margin-top: -10px"
                    size="small"
                    type="success"
                    @click="submitUpload"
                    :disabled="file.disabled"
                  >上传</el-button>
                </template>
                <template v-else-if="file.type == 'uploadImagePdf'">
                  <el-button
                    slot="trigger"
                    size="small"
                    :disabled="file.disabled"
                    type="primary"
                  >选取文件</el-button
                  >
                  <el-button
                    style="margin-left: 10px; margin-top: -10px"
                    size="small"
                    type="success"
                    @click="submitUpload"
                    :disabled="file.disabled"
                  >上传</el-button>
                </template>
                <template v-else>
                  <el-button
                    slot="trigger"
                    size="small"
                    :disabled="file.disabled"
                    type="primary"
                  >选取文件</el-button
                  >
                  <el-button
                    style="margin-left: 10px; margin-top: -10px"
                    size="small"
                    type="success"
                    @click="submitUpload"
                    :disabled="file.disabled"
                  >上传</el-button
                  >
                  <div
                    @click="handleClick(file.templateEvent)"
                    slot="tip"
                    class="el-upload__tip"
                  >
                    <el-link
                      href="#"
                      type="success"
                      style="color: #06c; font-size: 13px"
                    >下载{{ file.name }}模板</el-link
                    >
                  </div>
                </template>
              </el-upload>
            </el-form-item>
          </el-form>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </template>
      </el-card>
    </el-col>
  </el-row>
</template>
<script>
  import cities from "@/common/cities"; // 引入城市数据

  export default {
    props: {
      // 自定义类名
      className: {
        type: String,
      },
      //表单标题
      formTitle: {
        type: String,
      },
      //表头备注
      remark: {
        type: String,
      },
      //表格
      table: {
        type: Object,
      },
      //文件上传
      file: {
        type: Object,
        default: () => {
          return {
            show: false,
            isNeedReplace: false
          }
        }
      },
      // 表单数据
      data: {
        type: Object,
      },
      // 相关字段
      fieldList: {
        type: Array,
      },
      // 验证规则
      rules: {
        type: Object,
      },
      // 相关的列表
      listTypeInfo: {
        type: Object,
      },
      refObj: {
        type: Object,
      },
      //阴影效果
      shadow: {
        type: String,
      },
      //不显示边框
      noBorder: {
        type: Boolean,
      },
    },
    data() {
      return {
          option:{
disabledDate(date) {
    //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
    return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
  }
      },
        form: {
          carriers: "全部",
        },
        dialogImageUrl: "",
        dialogVisible: false,
        citiesOP: cities,

      };
    },
    computed: {
      getTableConfigList() {
        return this.table.fieldList.filter(
          (item) =>
            !item.hasOwnProperty("show") ||
            (item.hasOwnProperty("show") && item.show)
        );
      },
    },
    watch: {
      data: {
        handler: function (val) {
          // 将form实例返回到父级
          this.$emit("update:refObj", this.$refs.pageform);
          if (this.table) {
            this.$emit("update:refObj", this.$refs.formTable);
          }
        },
        deep: true, // 深度监听
      },
      file() {
        setTimeout(() => {
          this.file.ref = this.$refs.upload;
        }, 0);
      },
    },
    mounted() {
      // 将form实例返回到父级
      this.$emit("update:refObj", this.$refs.pageform);
      if (this.table) {
        this.$emit("update:refObj", this.$refs.formTable);
      }
      if (this.file) {
        console.log(this.file,'===========file============');
        this.file.ref = this.$refs.upload;
        this.file.submitObj = new FormData();
      }
    },
    methods: {

      onSubmit() {
        this.$message({
          message: "提交成功！",
          type: "success",
        });
        this.$emit("update:visible", false); // 直接修改父组件的属性
      },
      onCancel() {
        this.$message({
          message: "取消",
          type: "warning",
        });
        this.$emit("update:visible", false); // 直接修改父组件的属性
      },
      modalClose() {
        this.$emit("update:visible", false); // 直接修改父组件的属性
      }, // 获取字段列表
      getConfigList() {
        return this.fieldList.filter(
          (item) =>
            !item.hasOwnProperty("show") ||
            (item.hasOwnProperty("show") && item.show)
        );
      },
      // 得到placeholder的显示
      getPlaceholder(row) {
        let placeholder;
        if (row.type === "input" || row.type === "textarea") {
          placeholder = "请输入" + this.$t(row.label);
        } else if (
          row.type === "select" ||
          row.type === "time" ||
          row.type === "date" ||
          row.type === "picker"
        ) {
          placeholder = "请选择" + this.$t(row.label);
        } else if (row.type === "number") {
          placeholder = "请输入数字";
        } else {
          placeholder = this.$t(row.label);
        }
        return placeholder;
      },
      handleExceed(files, fileList) {//文件超出个数限制时的钩子，fileList：历史选中的文件，files：本次选中的文件
        let fileLimit = this.file.limit;
        let canChooseFileNum = fileLimit - fileList.length;
        if ((this.file.isNeedReplace && this.file.isNeedReplace === true && canChooseFileNum == 0 && fileLimit == 1 && files.length == 1)) {
          this.$set(fileList[0], 'raw', files[0]);
          this.$set(fileList[0], 'name', files[0].name);
          this.$refs['upload'].clearFiles();//清除文件
          this.$refs['upload'].handleStart(files[0]);//选择文件后的赋值方法
          this.$message.info("最多只能上传" + this.file.limit + "个文件，已为您替换成最新的文件！");
        } else {
          if (canChooseFileNum == 0) {
            this.$message.warning("您本次已达到可上传文件的上限(" + fileLimit + "个)，请提交后，再次上传!");
          } else if (files.length > canChooseFileNum) {
            this.$message.warning("您本次最多可以选择" + canChooseFileNum + "个文件");
          } else {
            this.$message.warning("最多只能上传" + fileLimit + "个文件");
          }
        }
      },
      beforeUpload(file) {
        this.file.submitObj = this.file.submitObj || new FormData();
        this.file.submitObj.append("uploadFile", file);
        return false;
      },
      submitUpload() {
        this.$refs.upload.submit();
        let fileName = this.file.submitObj.get("uploadFileName");
        this.handleClick(this.file.event, this.file.submitObj);
        this.file.submitObj = new FormData();
      },
      tableRowKey(row) {
        return row.id;
      },
      tableRowClassName({ row }) {
        if (row.rejectQty > 0) {
          return "warning-row";
        }
        return "";
      },
      //删除图片
      handleRemove(file) {},
      // 绑定的相关事件
      handleEvent(evnet, data) {
        this.$emit("handleEvent", evnet, data);
      },
      // 派发按钮点击事件
      handleClick(event, data) {
        this.$emit("handleClick", event, data);
      },
      // 选中数据
      handleSelectionChange(value) {
        this.$emit("handleEvent", this.table.event, value);
      },
      //select框远程搜索
      remoteMethod(item, query) {
        item.loading = false;
        this.handleEvent(item.remoteMethod, query);
      },
    },
  };
</script>
<style scoped>
  .no-border {
    border: 0;
  }
  .remark{
    color: red;
    font-size: 11px;
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog-form.vue